function hasClass(elements, cName) {
    return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)")); // ( \\s|^ ) 判断前面是否有空格 （\\s | $ ）判断后面是否有空格 两个感叹号为转换为布尔值 以方便做判断 
};

function removeClass(elements, cName) {
    if (hasClass(elements, cName)) {
        elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " "); // replace方法是替换 
    };
};

function addClass(elements, cName) {
    if (!hasClass(elements, cName)) {
        elements.className += " " + cName;
    };
};

function bind(elem, ev, callback) {
    if (document.all) {
        elem.attachEvent("on" + ev, callback);
    } else {
        elem.addEventListener(ev, callback, false);
    }
}

function unbind(elem, ev, callback) {
    if (typeof (callback) == "function") {
        if (document.all) {
            elem.detachEvent("on" + ev, callback);
        } else {
            elem.removeEventListener(ev, callback, false);
        }
    } else {
        if (document.all) {
            elem.detachEvent("on" + ev);
        } else {
            elem.removeEventListener(ev, false);
        }
    }
}

function hover(elem, overCallback, outCallback) { //实现hover事件
    var isHover = false; //判断是否悬浮在上方
    var preOvTime = new Date().getTime(); //上次悬浮时间
    function over(e) {
        var curOvTime = new Date().getTime();
        isHover = true; //处于over状态
        if (curOvTime - preOvTime > 10) { //时间间隔超过10毫秒，认为鼠标完成了mouseout事件
            overCallback(e, elem);
        }
        preOvTime = curOvTime;
    }

    function out(e) {
        var curOvTime = new Date().getTime();
        preOvTime = curOvTime;
        isHover = false;
        setTimeout(function () {
            if (!isHover) {
                outCallback(e, elem);
            }
        }, 10);
    }
    bind(elem, "mouseover", over);
    bind(elem, "mouseout", out);
};
module.exports = {
    hasClass: hasClass,
    addClass: addClass,
    removeClass: removeClass,
    hover: hover
}